import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";
import { AddInvoiceComponent } from "../add-invoice/add-invoice.component";
import { EditInvoiceComponent } from "../edit-invoice/edit-invoice.component";
import { MatDialog } from "@angular/material/dialog";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-detail-tracker",
  templateUrl: "./detail-tracker.component.html",
  styleUrls: ["./detail-tracker.component.css"],
})
export class DetailTrackerComponent {
  trackerId: string;
  particlarLR: any;
  clientName: string = "N/A";

  constructor(
    private route: ActivatedRoute,
    private superAdminService: SuperAdminService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.trackerId = this.route.snapshot.paramMap.get("id");
    if (this.trackerId) {
      this.loadTracker(this.trackerId);
    }
  }

  loadTracker(id: string) {
    this.spinner.show();

    this.superAdminService.particlarTracker(id).subscribe({
      next: (res) => {
        if (res.status) {
          this.particlarLR = {
            ...res.data,
            vehicleDetail: res.data.vehicleDetail,
            invoice_no: res.data.invoice_no || [],
          };

          this.clientName = res.data.clientName || "N/A";

          this.spinner.hide();
        } else {
          this.toastr.error(res.message || "Tracker not found");
          this.spinner.hide();
        }
      },
      error: (err) => {
        this.toastr.error("Error fetching tracker details");
        this.spinner.hide();
      },
    });
  }

  getLRDetail(id: string) {
    this.superAdminService.particlarTracker(id).subscribe({
      next: (res) => {
        if (res.status) {
          this.particlarLR = {
            ...res.data,
            vehicleDetail: res.data.vehicleDetail,
            invoice_no: res.data.invoice_no || [],
          };

          this.clientName = res.data.clientName || "N/A";
        } else {
          this.toastr.error(res.message || "Tracker not found");
        }
      },
      error: (err) => {
        console.error("Error fetching tracker:", err);
        this.toastr.error("Error fetching tracker details");
      },
    });
  }

  addnewinv(acc: any) {
    this.dialog.open(AddInvoiceComponent, {
      panelClass: "addInvoice",
      data: {
        acc,
        getLrDetail: () => this.getLRDetail(this.trackerId),
      },
    });
  }

  editInvoice(acc, id, trackerId: string): void {
    this.dialog.open(EditInvoiceComponent, {
      panelClass: "addInvoice",
      data: {
        acc,
        id,
        trackerId,
        getLrDetail: () => {
          this.getLRDetail(id);
        },
      },
    });
  }

  backTo() {
    window.history.back();
  }
}
